export type CnpjTelefone = {
  ddd: string;
  numero: string;
};

export type CnpjSocio = {
  nome_socio: string | null;
  identificador_socio: string | number | null;
  qualificacao_socio: string | null;
  data_entrada_sociedade: string | null;
  faixa_etaria: string | null;
  cpf_socio: string | null;
};

export type CnpjConsulta = {
  cnpj: string;
  razao_social: string | null;
  nome_fantasia: string | null;
  situacao_cadastral: string | null;
  data_inicio_atividade: string | null;
  cnae_principal: string | null;
  cnae_fiscal_descricao: string | null;
  porte_empresa: string | null;
  email: string | null;
  telefones: CnpjTelefone[];
  logradouro: string | null;
  numero: string | null;
  complemento: string | null;
  bairro: string | null;
  municipio: string | null;
  uf: string | null;
  cep: string | null;
  endereco_empresa: string | null;
  QSA: CnpjSocio[];
  opcao_pelo_simples: boolean | null;
  fonte_consulta?: string;
  fonte_qsa?: string;
  fonte_simples?: string;
  consulta_manual?: boolean;
  message?: string;
};

export function nomeEmpresa(payload: { nome_fantasia?: string | null; razao_social?: string | null }) {
  const fantasia = payload.nome_fantasia?.trim() ?? "";
  const razao = payload.razao_social?.trim() ?? "";
  return fantasia || razao;
}

export function isSocioPf(identificador: unknown) {
  if (typeof identificador === "number" || (typeof identificador === "string" && /^\d+$/.test(identificador.trim()))) {
    const codigo = Number(identificador);
    return codigo === 2 || codigo === 3;
  }
  const id = String(identificador ?? "").trim().toLowerCase();
  if (!id) return false;
  return id.includes("física") || id.includes("fisica") || id === "pf" || id === "pessoa fisica";
}

export function sociosPf(qsa: CnpjSocio[] | undefined) {
  return (qsa ?? []).filter((row) => row.nome_socio?.trim() && isSocioPf(row.identificador_socio));
}

export function payloadManual(cnpj: string): CnpjConsulta {
  return {
    cnpj,
    razao_social: null,
    nome_fantasia: null,
    situacao_cadastral: null,
    data_inicio_atividade: null,
    cnae_principal: null,
    cnae_fiscal_descricao: null,
    porte_empresa: null,
    email: null,
    telefones: [],
    logradouro: null,
    numero: null,
    complemento: null,
    bairro: null,
    municipio: null,
    uf: null,
    cep: null,
    endereco_empresa: null,
    QSA: [],
    opcao_pelo_simples: null,
    consulta_manual: true,
    message: "Consulta automática indisponível para este CNPJ. Preencha os dados manualmente.",
  };
}
